import { Blog } from '@/core/domain/blog/models/blog.model';
import { BlogRepository } from '@/core/domain/blog/repositories/blog.repository';
import { environment } from '@/env/environment';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, of, switchMap } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class BlogImplRepository extends BlogRepository {
    constructor(private readonly httpClient: HttpClient) {
        super();
    }

    override getBlogs(): Observable<Blog> {
        return this.httpClient
            .get(
                [
                    environment.alamoApi.BASE_HOST,
                    environment.alamoApi.ENDPOINTS.blogs,
                ].join('/'),
            )
            .pipe(
                switchMap((blogResponse: Blog) => {
                    const blog: Blog = {
                        type: blogResponse.type,
                        action: blogResponse.action,
                        notifications: blogResponse.notifications,
                        data: blogResponse.data,
                    };

                    return of(blog);
                }),
            );
    }
}
